"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortAlphabeticallyBy = void 0;
function sortAlphabeticallyBy(list, key) {
    return list.sort(function (a, b) {
        if (a[key] > b[key]) {
            return 1;
        }
        if (a[key] < b[key]) {
            return -1;
        }
        return 0;
    });
}
exports.sortAlphabeticallyBy = sortAlphabeticallyBy;
//# sourceMappingURL=sortAlphabeticallyBy.js.map